import type {
    GetActiveEmploymentsResponse,
    GetActiveRequestsResponse,
} from '@common/interfaces/api/accountDeactivationApi';
import type { IDeactivateEmploymentValidated } from '@common/validation/employment';
import { fetchJson } from '@frontend/store/fetch';

export async function getActiveEmployments(
    organizationId: string,
    signal: AbortSignal
): Promise<GetActiveEmploymentsResponse> {
    const url = `/api/employments/${organizationId}/practitioners?isActive=true&isEndDateNull=true`;
    const result = await fetchJson<GetActiveEmploymentsResponse>({
        method: 'GET',
        signal,
        url,
    });

    return result.json ?? { items: [] };
}

export async function hasActiveRequests(employmentId: string, signal: AbortSignal): Promise<boolean> {
    const url = `/api/requests/active?employmentId=${employmentId}`;
    const result = await fetchJson<GetActiveRequestsResponse>({
        method: 'GET',
        signal,
        url,
    });

    return result.json?.hasActiveActivities ?? false;
}

export async function deactivateAccount(
    employmentId: string,
    deactivateEmploymentValidated: IDeactivateEmploymentValidated,
    signal: AbortSignal
): Promise<void> {
    const url = `/api/employments/${employmentId}/deactivate`;

    const body = deactivateEmploymentValidated;

    await fetchJson({ body, method: 'POST', signal, url });
}
